import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AuthfakeauthenticationService } from '../../core/services/auth.service';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})

export class TopbarComponent implements OnInit {
  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;
  public user: any
  userProfile: any;

  constructor(@Inject(DOCUMENT) private document: any, private router: Router,
    private authFackservice: AuthfakeauthenticationService,
  ) {
  }

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {
    this.openMobileMenu = false;
    this.element = document.documentElement;
    this.user = JSON.parse(localStorage.getItem("currentUser"));

    var data = JSON.parse(sessionStorage.getItem('currentUserProfile'));
    
      if(data !== null)
      {
        this.userProfile = data;
      }
      else
      {
        this.userProfile = "assets/images/default.png";
      }
  }
  /**
     * Toggle the menu bar when having mobile screen
     */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  toggleMenu(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.document.body.classList.toggle('sidebarclass');
    let sidebarRef = this.document.getElementById('sidebar');
    sidebarRef.classList.toggle('collapsed');
    let sidebarReff = this.document.getElementById('imgaeexpand');
    sidebarReff.classList.toggle('collapsedd');

    let menuHide = this.document.querySelectorAll('.sub-menu-list') as any;
    menuHide.forEach((element) => {
      if (this.document.body.classList.contains('sidebarclass')) {
        element.style.display = 'none';
      } else {
        element.style.display = 'none';
      }
    });
  }


  ChangePassword() {
    this.router.navigate(['/changePassword']);

  }



  /**
   * Logout the user
   */
  logout() {
    this.authFackservice.logout();
    this.router.navigate(['/account/login']);

  }


  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
}

